import { render } from "./PageHeaderPortal.vue?vue&type=template&id=a7c4ff68"
import script from "./PageHeaderPortal.vue?vue&type=script&lang=js"
export * from "./PageHeaderPortal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__